import React from "react";
import { Button, Grid } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import appScreen2 from "../../../assets/Images/appScreen2.jpg";
import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

function ApplicationScreen1() {
  // const label = { inputProps: { "aria-label": "Switch demo" } };

  return (
    <>
      <div className="applicationScreensDiv">
        <div className="applicationScreensHead">Screen 1 - Login Screen</div>
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className="applicationScreenLeft">
              <FormControlLabel
                control={<Switch />}
                label="Access to All Data"
              />
              <h5 className="selectFildHeading">Select modules & fields</h5>
              <FormGroup className="appliCheckOuter">
                <FormControlLabel
                  control={<Checkbox />}
                  label="Security Guard Name"
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Mobile Number"
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Current Assignment"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Check In & Check Out Time"
                />
              </FormGroup>

              <div className="appliBtOuter">
                <Button className="addBt">Give Access</Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="applicationScreenRight">
              <div className="appsScreenDiv">
                <Zoom>
                  <img
                    src={appScreen2}
                    alt="That Wanaka Tree, New Zealand by Laura Smetsers"
                  />
                </Zoom>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ApplicationScreen1;
